import React from "react";
import LogoLockup from "./icons/LogoLockup.jsx";
import COMPANY from "../data/company.js";
import { NAV } from "../pages/registry.js";

const Footer = ({ go }) => (
  <footer className="foot">
    <div className="wrap">
      <div className="foot-grid">
        <div>
          <div className="brand" style={{ cursor: "default" }}>
            <LogoLockup variant="light" className="foot-lockup" />
          </div>
          <p style={{ marginTop: 22, fontSize: ".93rem", maxWidth: "34ch" }}>
            Driven by trust. Powered by reliability. Courier and heavy goods transport across the
            United Kingdom and Ireland.
          </p>
          <div className="soc" aria-label="Social media">
            {["in", "X", "f"].map((s) => (
              <span key={s} role="link" tabIndex={0} aria-label={"Social profile " + s}
                    style={{ fontFamily: "var(--display)", fontSize: ".85rem", fontWeight: 700 }}>{s}</span>
            ))}
          </div>
        </div>
        <div>
          <h4>Quick links</h4>
          {NAV.map(([k, l]) => <button key={k} onClick={() => go(k)}>{l}</button>)}
          <button onClick={() => go("contact")}>Request a quote</button>
        </div>
        <div>
          <h4>Services</h4>
          <button onClick={() => go("fleet")}>Courier transport</button>
          <button onClick={() => go("fleet")}>Heavy goods</button>
          <button onClick={() => go("fleet")}>Dedicated transport</button>
          <button onClick={() => go("fleet")}>Business logistics</button>
        </div>
        <div>
          <h4>Contact</h4>
          <a href={COMPANY.phoneHref}>{COMPANY.phone}</a>
          <a href={COMPANY.emailHref}>{COMPANY.email}</a>
          <p style={{ fontSize: ".93rem", lineHeight: 1.7 }}>
            {COMPANY.name}<br />{COMPANY.address.line1}<br />{COMPANY.address.city} {COMPANY.address.postcode}<br />{COMPANY.address.country}
          </p>
          <p style={{ fontSize: ".82rem", marginTop: 12, color: "rgba(255,255,255,.5)" }}>
            Registered in England &amp; Wales · Company no. {COMPANY.companyNumber}
          </p>
        </div>
      </div>
      <div className="foot-bot">
        <span>© {new Date().getFullYear()} A4 Express Ltd. All rights reserved.</span>
        <div>
          <button onClick={() => go("privacy")}>Privacy Policy</button>
          <button onClick={() => go("terms")}>Terms &amp; Conditions</button>
          <button onClick={() => go("contact")}>Enquiries</button>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
